export default __webpack_public_path__ + "locales/nl/JavascriptSdk.json?hash=a7933dbe36fce22f5c728b3109b11800";